import * as React from 'react'
import {Global, css} from '@emotion/core'

type PropsType = {
  languageCode: string
}

const FALLBACK_FONT_LANGUAGES = new Set([
  'ar',
  'he',
  'ja',
  'ko',
  'th',
  'zh',
  'zh-CN',
  'zh-HK',
  'zh-TW'
])

const fallBackFontFaces = css`
  @font-face {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: normal;
    src: local('.SFNSText-Regular'),
      local('.HelveticaNeueDeskInterface-Regular'), local('.LucidaGrandeUI'),
      local('Ubuntu Regular'), local('Segoe UI Regular'),
      local('Roboto-Regular'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 500;
    src: local('.SFNSText-Medium'), local('.HelveticaNeueDeskInterface-Medium'),
      local('.LucidaGrandeUI'), local('Ubuntu Medium'), local('Segoe UI Medium'),
      local('Roboto-Medium'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 600;
    src: local('.SFNSText-Semibold'),
      local('.HelveticaNeueDeskInterface-Semibold'), local('.LucidaGrandeUI'),
      local('Ubuntu Semibold'), local('Segoe UI Semibold'),
      local('Roboto-Semibold'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    src: local('.SFNSText-Bold'), local('.HelveticaNeueDeskInterface-Bold'),
      local('.LucidaGrandeUI'), local('Ubuntu Bold'), local('Segoe UI Bold'),
      local('Roboto-Bold'), local('DroidSans'), local('Tahoma');
  }
`

const fontFaces = () => css`
  @font-face {
    font-family: 'Proxima Nova';
    src: url('https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/l?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n7&v=3')
        format('woff2'),
      url('https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/d?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n7&v=3')
        format('woff'),
      url('https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/a?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n7&v=3')
        format('opentype');

    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/l?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n6&v=3')
        format('woff2'),
      url('https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/d?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n6&v=3')
        format('woff'),
      url('https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/a?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n6&v=3')
        format('opentype');

    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('https://use.typekit.net/af/6e816b/00000000000000003b9b3064/27/l?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n5&v=3')
        format('woff2'),
      url('https://use.typekit.net/af/6e816b/00000000000000003b9b3064/27/d?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n5&v=3')
        format('woff'),
      url('https://use.typekit.net/af/6e816b/00000000000000003b9b3064/27/a?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n5&v=3')
        format('opentype');

    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/l?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n4&v=3')
        format('woff2'),
      url('https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/d?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n4&v=3')
        format('woff'),
      url('https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/a?primer=61f6172816bf5073ee42c9c639f341f3282bc9de3ad2ec02e6d58d61bda3c6c5&fvd=n4&v=3')
        format('opentype');

    font-style: normal;
    font-weight: 400;
  }
`

const FontsLoader = ({languageCode}: PropsType) => {
  const styles = FALLBACK_FONT_LANGUAGES.has(languageCode)
    ? fallBackFontFaces
    : fontFaces()

  return <Global styles={styles} />
}

export default FontsLoader
